module.exports = __webpack_public_path__ + "store/img/tag-placeholder.e5037a81.svg";